/* shared janky scripts for all pages */

// hit counter (ticks up for fun)
(function(){
  var el=document.getElementById('counter');
  if(!el)return;
  var n=1337;
  setInterval(function(){n++;el.textContent=('0000000'+n).slice(-7);},4000);
})();

// booking form -> mock confirmation (real Shopify version emails you)
function fakeBook(e){
  e.preventDefault();
  var c=document.getElementById('bookConfirm');
  c.style.display='block';
  c.innerHTML="✅ <b>Sent!</b> (mockup) — the real site emails you at ink@fatmum.co.uk and you reply to sort a date and deposit.";
  c.scrollIntoView({behavior:'smooth',block:'center'});
  return false;
}

// booking: fill the date dropdown from availability.js
(function(){
  var sel=document.getElementById('bookdate');
  if(!sel)return;
  var work=(typeof WORK_DAYS!=='undefined')?WORK_DAYS:[0,1,5];
  var booked=(typeof BOOKED_DATES!=='undefined')?BOOKED_DATES:[];
  var weeks=(typeof WEEKS_AHEAD!=='undefined')?WEEKS_AHEAD:8;
  var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var today=new Date();today.setHours(0,0,0,0);
  var end=new Date(today);end.setDate(end.getDate()+weeks*7);
  var d=new Date(today);d.setDate(d.getDate()+1);
  var added=0;
  for(;d<=end;d.setDate(d.getDate()+1)){
    if(work.indexOf(d.getDay())===-1)continue;
    var iso=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
    if(booked.indexOf(iso)!==-1)continue;
    var o=document.createElement('option');
    o.value=iso;
    o.textContent=days[d.getDay()]+' '+d.getDate()+' '+months[d.getMonth()];
    sel.appendChild(o);
    added++;
  }
  if(!added){var o=document.createElement('option');o.textContent='No free dates right now — email me!';sel.appendChild(o);}
})();

// booking: preview uploaded reference images
function showRefs(){
  var inp=document.getElementById('refs'),box=document.getElementById('refList');
  box.innerHTML='';
  if(!inp.files.length)return;
  var note=document.createElement('div');note.className='note';
  note.textContent=inp.files.length+' file'+(inp.files.length>1?'s':'')+' attached:';
  box.appendChild(note);
  for(var k=0;k<inp.files.length;k++){
    var f=inp.files[k];
    if(f.type.indexOf('image')!==0)continue;
    var im=document.createElement('img');im.className='refthumb';im.alt=f.name;im.title=f.name;
    im.src=URL.createObjectURL(f);
    box.appendChild(im);
  }
}

// password gate (DEMO ONLY — client-side, not real security)
function tryPw(){
  var v=document.getElementById('pwInput').value.trim().toLowerCase();
  var pw=((window.SECRET_PW||'stabby')+'').trim().toLowerCase();
  if(v===pw){
    document.getElementById('gateLocked').style.display='none';
    document.getElementById('gateOpen').style.display='block';
  }else{
    document.getElementById('pwError').style.display='block';
  }
}
function lockVault(){
  document.getElementById('gateOpen').style.display='none';
  document.getElementById('gateLocked').style.display='block';
  document.getElementById('pwInput').value='';
  document.getElementById('pwError').style.display='none';
}

// (the drop countdown now runs inline in the shop section)

// shop: notify-me signup (mock)
function notify(e){
  e.preventDefault();
  var c=document.getElementById('notifyConfirm');
  if(c){c.style.display='block';c.innerHTML="✅ You're on the list — we'll email you the second the next drop opens.";}
  return false;
}

// capture forms: AJAX submit so each form shows ONLY its own confirmation
// (Shopify's {% form 'customer' %} sets a page-wide success flag — this avoids that)
(function(){
  function wire(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var msg=form.getAttribute('data-done')||"✅ You're on the list!";
      var btn=form.querySelector('button[type=submit]')||form.querySelector('button');
      if(btn){btn.disabled=true;btn.textContent='…';}
      fetch(form.action,{method:'POST',body:new FormData(form),headers:{'Accept':'text/html, */*'}})
        .then(function(res){
          if(!res.ok){throw new Error('HTTP '+res.status);}
          var ok=document.createElement('div');
          ok.className='capture-ok';
          ok.style.cssText='color:#006000;font-weight:bold;margin-top:8px;';
          ok.textContent=msg;
          if(form.parentNode){form.parentNode.replaceChild(ok,form);}
        })
        .catch(function(){
          if(btn){btn.disabled=false;}
          alert('Something went wrong — please try again, or email me.');
        });
    });
  }
  document.querySelectorAll('form.capture-form').forEach(wire);
})();

// guestbook live sign
function signGb(){
  var i=document.getElementById('gbInput'),t=i.value.trim();
  if(!t)return;
  var d=document.createElement('div');
  d.className='gb-entry';
  d.innerHTML='<b>you</b> — '+t.replace(/</g,'&lt;');
  i.parentNode.parentNode.insertBefore(d,i.parentNode);
  i.value='';
}
